<template>
    <b-alert show>
        {{$t('pages.selfservice.registration.emailValidation')}}
    </b-alert>
</template>

<script>
/**
 * @description Stage for handling email validation
 *
 **/
export default {
    name: 'Email-Validation'
};
</script>
